/* esm.sh - date-fns@4.1.0/_lib/defaultLocale */
import{enUS as o}from"../locale/en-US.mjs";export{o as defaultLocale};
//# sourceMappingURL=defaultLocale.mjs.map